module.exports = __webpack_public_path__ + "static/media/video_back.024e8381.webm";